import React from "react";

import Drag from "../FormComponent/Drag";
import Bin from "../FormComponent/Bin";
import Close from "../FormComponent/Close";
import Copy from "../FormComponent/Copy";
import FieldLabel from "./InputTypes/FieldLabel";
import FieldRequired from "./InputTypes/FieldRequired";
import FieldType from "./InputTypes/FieldType";

const updateField = ["Label", "Required", "PlaceHolder"];

const Radio = (props) => {

  const isTemplateMode = props.mode === "Template";
  
  return (
    <div className={`${isTemplateMode ? `p-9` : ``} form-group field-wraper`}>
      <div className={`field-content ${isTemplateMode ? `row` : ``}`}>
        
        {isTemplateMode ? <div className="col-md-1 pl-0"><Drag /></div> : null}
        
        <div className={isTemplateMode ? `col-md-4` : `col-md-12`}>
          <FieldLabel
            idValue={props.fieldItem.fieldId}
            errors={props.errors}
            value={props.fieldItem.fieldLabel}
            changeHandler={(event) =>
              props.updatedField(event, props.fieldItem.fieldId, updateField[0])
            }
          />
          
        </div>
        <div className={isTemplateMode ? `col-md-4` : `col-md-12 mt-5`}>
          <FieldType
            changeFieldHandler={(event) =>
              props.changeFieldHandler(
                event,
                props.fieldItem.fieldId,
                props.fieldItem.inputType,
                props.sectionId
              )
            }
            inputType={props.fieldItem.inputType}
          />
        </div>
        <div className={isTemplateMode ? `col-md-2 pl-0` : `col-md-12`} >
          <FieldRequired
            fieldId={props.fieldItem.fieldId}
            isChecked={props.fieldItem.fieldRequired}
            changeHandler={(event) =>
              props.updatedField(event, props.fieldItem.fieldId, updateField[1])
            }
          />
        </div>
        {isTemplateMode ? (
        <div className="col-md-1 d-flex">
          <Copy
            copyFieldHandler={() =>
              props.copyFieldHandler(
                props.fieldItem.fieldId,
                props.fieldItem.inputType,
                props.sectionId
              )
            }
          />
          {props.index > 0 && (
            <Bin
              deleteHandler={() =>
                props.deleteFieldHandler(props.fieldItem.fieldId)
              }
            />
          )}
        </div>) : null }
        <div className={isTemplateMode ? `col-md-4 offset-md-1` : `col-md-12`} >
          <div className="row pt-5">
            <div className="d-flex">
              <label>Dropdown options</label>
            </div>
          </div>
          <div className="row d-flex">
            {props.fieldItem.options.map((option, index) => {
              const currentIndex = index + 1;
              let placeHolderValue = "Option " + currentIndex;
              return (
                <>
                  <div
                    key={option.optionId}
                    className={`d-flex align-items-center ${
                      !props.errors[option.optionId] ? "pb-3" : ""
                    }`}
                  >
                    <input
                      autoFocus
                      className={
                        props.errors[option.optionId] ? "error-input" : ""
                      }
                      type="text"
                      value={option.optionValue}
                      maxLength="20"
                      placeholder={placeHolderValue}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          props.addOptionHandler(props.fieldItem.fieldId);
                        }
                      }}
                      onChange={(event) =>
                        props.updateOptionValue(event, option.optionId)
                      }
                    />
                    {props.fieldItem.options.length > 1 ? (
                      <Close
                        deleteOptions={() =>
                          props.deleteOptionsHandler(
                            props.fieldItem.fieldId,
                            option.optionId
                          )
                        }
                      />
                    ) : null}
                  </div>
                  {props.errors[option.optionId] && (
                    <label className="error pb-3">Mandatory Field.</label>
                  )}
                </>
              );
            })}
          </div>
          <div className="row">
            <div className="d-flex">
              <div
                className="add-option-button"
                onClick={() => props.addOptionHandler(props.fieldItem.fieldId)}
              >
                + Add option
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Radio;
